/**
 * WordPress dependencies
 */
import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';
import React from 'react';

const Save = ({ attributes }) => {
  const { headingText, headingColor, textColor } = attributes;
  const blockProps = useBlockProps.save({ className: 'card-item' });

  return (
    <div {...blockProps}>
      <div
        className={'card-item__title-wrapper'}
        style={{ backgroundColor: headingColor }}
      >
        <p style={{ color: textColor }}>{headingText}</p>
      </div>
      <div className={'card-item__inner'}>
        <InnerBlocks.Content />
      </div>
    </div>
  );
};

export default Save;
